// frontend/src/pages/PreOrder_success.js
import Header from "../Header";
import Footer from "../Footer";
import { Link, useSearchParams } from "react-router-dom";

const NAVY = "#1B2A4A";
const GOLD = "#EAA00A";
const GREEN = "#3AA655";

const ACCESS_LINKS = {
  EBOOK: "https://juniorpersist.com/access-ebook",
  AUDIOBOOK: "https://juniorpersist.com/access-audiobook",
};

const PRODUCT_LABELS = {
  EBOOK: "eBook",
  AUDIOBOOK: "Audiobook",
  PAPERBACK: "Paperback",
  HARDCOVER: "Hardcover",
};

function PreOrder_success() {
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const code = searchParams.get("code");
  const accessLink = ACCESS_LINKS[type];
  const productLabel = PRODUCT_LABELS[type] || "book";
  const isDigital = Boolean(code && accessLink);

  return (
    <div>
      <Header />

      <div style={{ background: "#F4F5F7", padding: "50px 16px" }}>
        <div
          style={{
            maxWidth: 560,
            margin: "0 auto",
            background: "#FCFCFA",
            borderRadius: 18,
            padding: "44px 36px 36px",
            textAlign: "center",
            boxShadow: "0 10px 40px rgba(0,0,0,.06)",
          }}
        >
          {/* ===== Check icon ===== */}
          <div
            style={{
              width: 92,
              height: 92,
              borderRadius: "50%",
              border: `4px solid ${GREEN}`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 24px",
            }}
          >
            <i className="bi bi-check-lg" style={{ fontSize: 46, color: GREEN }}></i>
          </div>

          {/* ===== Title ===== */}
          <h1 style={{ color: NAVY, fontWeight: 800, fontSize: 30, marginTop: '-10px' }}>
            {isDigital ? "Your Purchase Was Successful!" : "Order Confirmed!"}
          </h1>

          <p style={{ color: "#3A3A3A", fontSize: 19, fontWeight: 200, marginTop: '-3px', marginBottom: 2 }}>
            Thank you for your purchase of
          </p>
          <p style={{ color: GOLD, fontWeight: 700, fontStyle: "italic", fontSize: 24, marginTop: 0 }}>
            Persist, Persist, Persist!
          </p>

          {/* ===== Divider with star ===== */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: '-20px' }}>
            <span style={{ flex: 1, height: 1, background: GOLD, maxWidth: 140 }}></span>
            <i className="bi bi-star-fill" style={{ color: GOLD, margin: "0 14px", fontSize: 16 }}></i>
            <span style={{ flex: 1, height: 1, background: GOLD, maxWidth: 140 }}></span>
          </div>

          {/* ===== Access code block (eBook / Audiobook only) ===== */}
          {isDigital && (
            <div
              style={{
                marginTop: 22,
                marginBottom: 8,
                border: `2px solid ${GOLD}`,
                borderRadius: 14,
                background: "#FBF3E7",
                padding: "24px 20px",
              }}
            >
              <div style={{ color: NAVY, fontWeight: 800, fontSize: 15, marginBottom: 12 }}>
                Your {productLabel} Access Code
              </div>
              <div
                style={{
                  display: "inline-block",
                  background: NAVY,
                  color: "#fff",
                  fontWeight: 800,
                  fontSize: 28,
                  letterSpacing: "0.15em",
                  padding: "12px 22px",
                  borderRadius: 10,
                  fontFamily: "'Courier New', monospace",
                }}
              >
                {code}
              </div>
              <div style={{ marginTop: 16 }}>
                <a
                  href={accessLink}
                  style={{
                    display: "inline-block",
                    background: GOLD,
                    color: "#fff",
                    fontWeight: 700,
                    fontSize: 14,
                    textDecoration: "none",
                    padding: "12px 28px",
                    borderRadius: 999,
                  }}
                >
                  Access Your {productLabel}
                </a>
              </div>
              <div style={{ color: "#7A7F87", fontSize: 12.5, marginTop: 14, lineHeight: 1.6 }}>
                Access your content here:
                <br />
                <a href={accessLink} style={{ color: GOLD }}>{accessLink}</a>
              </div>
              <div style={{ color: "#7A7F87", fontSize: 12, marginTop: 12, lineHeight: 1.6, fontStyle: "italic" }}>
                Please save this information for future reference. A copy has also been sent to your email address.
              </div>
            </div>
          )}

          {/* ===== Info rows ===== */}
          {isDigital ? (
            <InfoRow icon="bi-lock-fill">
              Your access is available instantly &mdash; no shipping required.
            </InfoRow>
          ) : (
            <>
              <InfoRow icon="bi-box-seam-fill">
                Your order has been received and will be shipped soon.
              </InfoRow>

              <InfoRow icon="bi-truck">
                Please allow up to <strong style={{ color: GOLD }}>7 business days</strong> for delivery.
              </InfoRow>
            </>
          )}

          <InfoRow icon="bi-envelope-fill">
            Questions? Reach out to our team at{" "}
            <strong style={{ color: NAVY }}>junior@persist.com</strong>.
          </InfoRow>

          <InfoRow icon="bi-heart-fill" last>
            Thank you for your support, and enjoy the journey!
          </InfoRow>

          {/* ===== Gift box ===== */}
          <div
            style={{
              marginTop: 28,
              border: `1.5px solid ${GOLD}`,
              borderRadius: 12,
              background: "#FBF3E7",
              padding: "12px 16px",
              display: "flex",
              alignItems: "center",
              gap: 12,
              textAlign: "left",
            }}
          >
            <i className="bi bi-gift-fill" style={{ fontSize: 24, color: GOLD, flexShrink: 0 }}></i>
            <div>
              <div style={{ color: NAVY, fontWeight: 700, fontSize: 13, lineHeight: 1.3, marginBottom: '-5px'  }}>
                Do you know someone else who would benefit from the story?
              </div>
              <a
                href="/BuyBook"
                style={{ color: GOLD, fontWeight: 700, fontSize: 13, textDecoration: "none" }}
              >
                Gift them a copy!
              </a>
            </div>
          </div>

          {/* ===== Footer signature ===== */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: 30 }}>
            <span style={{ flex: 1, height: 1, background: "#d9d9d9", maxWidth: 80 }}></span>
            <span style={{ margin: "0 14px", color: NAVY, fontStyle: "italic", fontSize: 17 }}>
              Team Persist
            </span>
            <span style={{ flex: 1, height: 1, background: "#d9d9d9", maxWidth: 80 }}></span>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

function InfoRow({ icon, children, last }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 18,
        textAlign: "left",
        padding: "8px 4px",
        borderBottom: last ? "none" : "1px solid #ECECEC",
      }}
    >
      <div
        style={{
          width: 32,
          height: 32,
          borderRadius: "50%",
          background: NAVY,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <i className={`bi ${icon}`} style={{ color: "#fff", fontSize: 12 }}></i>
      </div>
      <div style={{ color: "#2E2E2E", fontSize: 17, fontWeight: 200, lineHeight: 1.4 }}>{children}</div>
    </div>
  );
}

export default PreOrder_success
